import styled from "styled-components";
import { mediaMaxWidth } from "../../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: calc(100% - 40px);
  overflow: scroll;
`;

export const Form = styled.form`
  width: 500px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  position: relative;
  display: block;
  align-items: center;
  max-width: 490px;
  flex-flow: wrap;

  strong {
    margin: 0 3px;
  }

  span {
    font-weight: 700;
  }

  &.margin-bottom-10 {
    margin-bottom: 10px;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border: ${(props) => props.error !== null && "2px solid #79D9D9"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 10em;
  padding: 10px;
  position: relative;
  margin: 10px 0 40px 0;

  ::placeholder {
    opacity: 0.75;
    font-weight: 300;
    font-style: italic;
  }

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.tablet`
    height: 8em;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;

    ${mediaMaxWidth.smallPhone`
      font-size: 0.9em;
      margin: 5px;
    `}
  }
`;

export const Field = styled.div`
  position: relative;

  &.with-padding-top-10 {
    padding-top: 10px;
  }

 &.margin-top-15 {
    margin-top: 15px;
  }
`;

export const ActionConfirmation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1em;
  flex-direction: column;
  justify-content: space-evenly;

  span {
    font-weight: 700;
    margin: 0 4px;

    &:last-child {
      margin: 0 0 0 4px;
    }
  }
`;

export const ActionConfimationIcon = styled.div`
  font-size: 4em;
  color: #a8a8a8;
`;

export const ActionConfirmationMessage = styled.div`
  width: 500px;
  text-align: center;
`;

export const Error = styled.div`
  position: absolute;
  bottom: -5px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.smallPhone`
    bottom: 0;
  `}
`;

export const Note = styled.div`
  position: absolute;
  bottom: 14px;
  font-size: 0.9em;
  font-style: italic;
  left: -5px;
`;

export const Asterisk = styled.div`
  display: inline;
  font-size: 2em;
  top: ${(props) => (props.note ? "11px" : "-5px")};
  position: ${(props) => (props.note ? "relative" : "absolute")};
  margin-right: ${(props) => (props.note ? "5px" : "1px")};
`;

export const PlaceholderBtn = styled.div`
  font-weight: bold;
  background: #9c9c9c;
  border: 1px solid #9c9c9c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  color: #fff;
  padding: 10px 12px;
  font-family: Komet;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  cursor: not-allowed;
  min-height: 44px;
  margin: 5px 10px;

  ${mediaMaxWidth.smallPhone`
    font-size: 0.9em;
    margin: 5px;
  `}
`;

export const Select = styled.select`
  background-color: #fff;
  border: ${(props) =>
    props.error ? "2px solid #79D9D9" : "2px solid #e7e7e7"};
  height: 46px;
  width: 100%;
  margin: 5px 0 0 0;
  padding: 0 5px;
  border-radius: 4px;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const CheckBoxesGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;

  ${mediaMaxWidth.phone`
    flex-flow: unset;
    flex-direction: column;
  `}
`;

export const CheckBoxesGroupItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 5px 0 10px 0;

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const Indicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #402680;
  }
`;

export const CheckBoxWrap = styled.div`
  display: flex;
  margin: 5px 0 10px 0;
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${Indicator} {
    background: #79D9D9;
    border: 2px solid #79D9D9;

    &:after {
      display: block;
    }
  }
`;

export const CheckBoxLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin-bottom: 0px;
  cursor: pointer;
  font-weight: 400;
`;

export const Check = styled.div`
  display: block;
  position: absolute;
  left: 0;
  border: 3px solid #e7e7e7;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: "";
    border-radius: 100%;
    height: 10px;
    width: 10px;
    top: 2px;
    left: 2px;
    margin: auto;
    transition: background 0.1s linear;
  }
`;

export const Required = styled.span`
  font-weight: 500;
  font-size: 2em;
  position: absolute;
  top: -10px;
  right: -15px;
  color: #79D9D9;
`;

export const RejectionReasonLabel = styled.label`
  display: block;
  color: #333;
  font-size: 0.9em;
  margin-bottom: 5px;
  font-weight: 600;
  position: relative;
  display: inline-flex;
`;
